import { graphql } from 'gatsby';

import Layout from '../components/Layout/Layout';
import { featuredItems } from '../data/featuredItems';
import { Trans, useTranslation } from 'react-i18next';
import RunBusinessBlock from '../components/FeatureBlocks/RunBusinessBlock/RunBusinessBlock';
import FeatureCarousel from '../components/FeatureBlockElements/FeatureCarousel/FeatureCarousel';
import TrustedBlock from '../components/FeatureBlocks/TrustedBlock/TrustedBlock';
import TestimonialCarousel from '../components/FeatureBlocks/TestimonialCarousel/TestimonialCarousel';
import FullBleedBlock from '../components/FullBleedBlock/FullBleedBlock';
import TeamsBlock from '../components/FeatureBlocks/TeamsBlock/TeamsBlock';
import FeaturedIn from '../components/FeaturedIn/FeaturedIn';
import KeepExploringBlock from '../components/FeatureBlocks/KeepExploringBlock/KeepExploringBlock';
import PromoBlockLeft from '../components/FeatureBlocks/PromoBlockLeft/PromoBlockLeft';
import { TRANSLATION_COMPONENTS } from '../constants/constants';
import StarRatingBlock from '../components/FeatureBlocks/StarRatingBlock/StarRatingBlock';
import HomeHeroNew from '../components/Hero/HomeHeroNew/HomeHeroNew';

import '../styles/home.scss';

const ogTags = {
    url: 'https://www.honeybook.com/get',
    title: 'HoneyBook | Client relationships platform for independent businesses',
    description:
        'Simplify your workflow with HoneyBook—the AI-powered platform that brings all your leads, clients, projects, and payments together in one place. Start your free 7-day trial.',
    noIndex: true
};

export const carouselSlideData = [
    {
        id: 'bray',
        imageUrl: 'marketing_site/testimonial-avatars/bray-new.png'
    },
    {
        id: 'ashley',
        imageUrl: 'marketing_site/testimonial-avatars/ashley-new.png'
    },
    {
        id: 'alexis',
        imageUrl: 'marketing_site/testimonial-avatars/alexis-new.png'
    },
    {
        id: 'pamela',
        imageUrl: 'marketing_site/testimonial-avatars/pamela-new.png'
    },
    {
        id: 'amber',
        imageUrl: 'marketing_site/testimonial-avatars/amber-new.png'
    }
];

const slides = [
    {
        transKey: 'slide1',
        mediaUrl: 'marketing_site/home_page/slide1.gif',
        imageUrl: 'marketing_site/icons/client-relationships.png',
        buttonText: 'Client relationships'
    },
    {
        transKey: 'slide2',
        mediaUrl: 'marketing_site/home_page/Frame02_2x_15fps.gif',
        imageUrl: 'marketing_site/icons/project-management.png',
        buttonText: 'Project management'
    },
    {
        transKey: 'slide3',
        mediaUrl: 'marketing_site/home_page/Frame03_2x_15fps.gif',
        link: '/lp/ai-start',
        imageUrl: 'marketing_site/icons/AI.png',
        buttonText: 'HoneyBook AI'
    },
    {
        transKey: 'slideAutomations',
        mediaUrl: 'marketing_site/home_page/automations2.png',
        link: 'https://www.honeybook.com/lp/automations',
        imageUrl: 'marketing_site/icons/lightning.png',
        buttonText: 'Automations'
    },
    {
        transKey: 'slide4',
        mediaUrl: 'marketing_site/home_page/Frame04_2x_15fps.gif',
        imageUrl: 'marketing_site/icons/inytegrations.png',
        buttonText: 'Integrations'
    },
    {
        transKey: 'slide5',
        mediaUrl: 'marketing_site/home_page/Frame05_2x_15fps.gif',
        link: '/lp/finance',
        imageUrl: 'marketing_site/icons/finances.png',
        buttonText: 'Finances'
    }
];

const pills = [
    {
        transKey: 'clientRelationships',
        imageUrl: 'marketing_site/icons/client-relationships.png'
    },
    {
        transKey: 'projectManagement',
        imageUrl: 'marketing_site/icons/project-management.png'
    },
    {
        transKey: 'ai',
        imageUrl: 'marketing_site/icons/AI.png'
    },
    {
        transKey: 'automations',
        imageUrl: 'marketing_site/icons/lightning.png'
    },
    {
        transKey: 'integrations',
        imageUrl: 'marketing_site/icons/inytegrations.png'
    },
    {
        transKey: 'finance',
        imageUrl: 'marketing_site/icons/finances.png'
    }
];

const AutomationsHome = () => {
    const { t } = useTranslation();

    return (
        <Layout
            ogTags={ogTags}
            mobileStickyCTA
            slimNav
            slimFooter
            isCtaTest={true}
        >
            <div className="home home--automations">
                <HomeHeroNew customCtaText={t('registrationForm.tryForFree')} />
                <RunBusinessBlock customPills={pills} />
                <FeatureCarousel customSlides={slides} />
                <TrustedBlock />
                <TestimonialCarousel />
                <StarRatingBlock />
                <FullBleedBlock
                    customClass="home__make-living"
                    title={
                        <Trans
                            i18nKey="makeLiving.title"
                            components={TRANSLATION_COMPONENTS}
                        />
                    }
                    backgroundImage="https://res.cloudinary.com/honeybook/image/upload/f_auto,fl_lossy,q_auto/v1742247794/marketing_site/home_page/make-living.jpg"
                />
                <TeamsBlock />
                <FeaturedIn featuredItems={featuredItems} />
                <KeepExploringBlock />
                <PromoBlockLeft
                    title={t('PromoBlockLeftYellow.title')}
                    customClass="promo-block-left--yellow"
                    source="promo block left - yellow"
                    buttonStyle="primary--dark"
                />
            </div>
        </Layout>
    );
};

export default AutomationsHome;

export const query = graphql`
    query ($language: String!) {
        locales: allLocale(
            filter: {
                ns: {
                    in: ["common", "home", "checklistHero", "valuePropBlock"]
                }
                language: { eq: $language }
            }
        ) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;
